<template>
  <div>
    <div class="content">
        <div class="breadcrum warp">
            <a href="/">首页</a>
            <span>></span>
            <a class="host" href="">{{headTitle}}</a>
            <div v-if="isShow == true">
               <span>></span>
               <a class="host" href="">{{headText}}</a>
            </div>    
        </div>
    </div>
  </div>  
</template>
<script>
export default {
    props:['headTitle','isShow','headText']
}
</script>
<style scoped>
.content{
  margin-top: 10px;
  border-bottom: 1px solid #DCDCDC;
  margin-bottom: 30px;
  width: 100%;
}
.breadcrum{
  display: flex;
  align-items: center;
  margin: 0 auto;
  height: 30px;
  line-height:30px;
  padding-bottom: 10px;
  /* width: 78%; */
  /* margin-left: 10%; */
}
.breadcrum span{
  padding: 0px 5px;
  color: #9A9A9A;
}
.breadcrum a {
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #9A9A9A;
}
.breadcrum a.host{
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #343434;
}
</style>


// WEBPACK FOOTER //
// src/common/titleHead.vue